import styled from 'styled-components';

const Container = styled.div`
  z-index: 99999 !important;
`;

export default Container;
